import { staticSidebarJSWReportsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-jsw-reports-sidebar/index.tsx';
import type { JiraSoftwareReport } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-reports-sidebar-navigation/types.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useJiraSoftwareReports = () =>
	useResource<JiraSoftwareReport[] | null>(staticSidebarJSWReportsResource);
